import { createElement } from 'react';
import { a9 as LinkTextGroup$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var LinkTextGroup = function LinkTextGroup(props) {
  return /*#__PURE__*/createElement(LinkTextGroup$1, __assign({}, props));
};
LinkTextGroup.displayName = 'LinkTextGroup';

export { LinkTextGroup };
